<template>
  <div class="container">
    User profile page
  </div>
</template>

<script>
export default {
  name: "userProfile",

  data() {
    return {
      token: window.localStorage.getItem("access-token") || false // TOKEN
    };
  },
  created() {
    // SET SCROLL LEVEL TO 0 WHICH MEANS TO THE TOP
    window.scrollTo(0, 0);
    alert("it works!");
    // FETCH USER INFO
    ///////////////////////////////////////////////////////////
  },
  methods: {
    // ADD FEEDBACK
    ///////////////////////////////////////////////////////////
  }
};
</script>

<style lang="css" scoped></style>
